<template>
	<div class="weather-wrapper">
		<div class="city-weather">
			<template v-if="!loading">
				<div>
					<div class="p-2">
						<h4>{{ city.name.en }}</h4>
						{{ city.currentConditions.condition.en }}.
						{{ city.Temperature }} (feels like {{ city.FeelsLike }})
					</div>
					<div
						v-for="forecast in city.forecasts.slice(0, 4)"
						class="d-none d-md-block"
					>
						<p class="p-2">
							{{ forecast.period.textForecastName.en }}:
							{{ forecast.summary.en }}
						</p>
					</div>
				</div>

				<!-- <img :src="city.image" /> -->
				<div class="p-2">
					Data from <a :href="city.url.en">Weather Canada.</a>
				</div>
			</template>
			<template v-else> </template>
		</div>
	</div>
</template>
<script setup>
import { computed, onMounted, ref } from "vue";
// import * as Weather from "./weather";
// const Weather = require("./weather");
import Weather from "weather-canada";
const cityID = "qc-147";

const loading = ref(true);
const cities = ref([]);
const city = ref();

const weather = new Weather();
const feelsLike = computed(() => {
	return city.value.FeelsLike;
});

// city.value = await weather.get(cityID);;
// loading.value = false;

onMounted(() => {
	weather.get(cityID).then((c) => {
		city.value = c;
		loading.value = false;
	});
});
</script>
